// assets
import { IconDevices, IconLayoutList, IconSortAscending2, IconBookDownload } from '@tabler/icons';

// constant
const icons = { IconDevices, IconLayoutList, IconSortAscending2, IconBookDownload };

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
  id: 'sample-docs-roadmap',
  title: 'Device',
  type: 'group',
  children: [
    {
      id: 'purchase_device',
      title: 'Purchase Device',
      type: 'item',
      url: '/Procurement/purchase_device',
      icon: icons.IconDevices,
      breadcrumbs: false
    },
    {
      id: 'order_status',
      title: 'Order Status',
      type: 'item',
      url: '/Procurement/order_status',
      icon: icons.IconSortAscending2,
      breadcrumbs: false
    },
    // {
    //   id: 'branding',
    //   title: 'Branding',
    //   type: 'item',
    //   url: '/branding/brandlist',
    //   icon: icons.IconLayoutList,
    //   breadcrumbs: false
    // },
    // {
    //     id: 'download_branding',
    //     title: 'Download branding',
    //     type: 'item',
    //     url: '/branding/downloadBrand',
    //     icon: icons.IconBookDownload,
    //     breadcrumbs: false
    //   },

  ]
};

export default other;
